import { validateCNPJ } from "@caju-beneficios/validators";
import yup from "lib/yup-extended";

export const validations = yup.object({
  company_name: yup.string().required("Nome da empresa é obrigatório").max(255, "O campo deve ter no máximo 255 caracteres"),

  company_CNPJ: yup
    .string()
    .required("CNPJ é obrigatório")
    .test("cnpj format", "Informe um CNPJ válido", (value) =>
      validateCNPJ(value ?? "")
    ),

  employees: yup
    .string()
    .required("O número total de colaboradores é obrigatório"),

  partners_portfolio_CNPJ: yup.string().required("Este campo é obrigatório"),
});
